<template>
  <el-dialog
    :title="title"
    :before-close="closeDialog"
    :show-close="(active==3 || isAllFailed)"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="711px">
    <!--打印组件检测提示 -->
    <printWarningTip
      :dyAlertTitle="dyAlertTitle"
      :selectPrinterForm="formInfo"
    ></printWarningTip>
    <!--打印步骤展示 -->
    <div class="y-f y-f-jb y-f-a print-step">
      <div class="step1 y-t-ac">
        <div class="y-mb-5 y-p-r">
          <div v-if="active==1" class="print-text-icon text-active">1</div>
          <img v-else class="print-step-icon" src="@/assets/images/dianshang/printFinish.png" />
          <div class="print-line" :class="{'active-border': (active==2 || active ==3)}"></div>
        </div>
        <span :class="{'process-blue': active==1}">获取运单数据</span>
      </div>
      <div class="step2 y-t-ac">
        <div class="y-mb-5 y-p-r">
          <div v-if="active!==3" class="print-text-icon wait-gray" :class="{'text-active': active==2}">2</div>
          <img v-else class="print-step-icon" src="@/assets/images/dianshang/printFinish.png" />
          <div class="print-line" :class="{'active-border': active ==3}"></div>
        </div>
        <span :class="{'process-blue': active==2, 'wait-gray-text': active== 1}">开始打印</span>
      </div>
      <div class="step3 y-t-ac">
        <div class="y-mb-5">
          <div v-if="active!=3" class="print-text-icon wait-gray">3</div>
          <img v-else class="print-step-icon" src="@/assets/images/dianshang/printSuccess.png" />
        </div>
        <span :class="{'process-blue': active==3, 'wait-gray-text': active!= 3}">打印成功</span>
      </div>
    </div>
    <!--第一步提示语 -->
    <div class="tip-desp" v-if="active==1 && !isApplyOrderFinished">正在为：<span class="y-fc-4C84FF">{{curOrderNumber}}</span> 获取运单数据，等待中请勿操作当前页面</div>
    <!--第二步提示语及进度条 -->
    <div class="tip-desp y-fs-16" v-if="active==2">
      <div>正在向打印机发送数据......</div>
      <el-progress :percentage="printPercentage" :stroke-width="8" style="width: 400px;margin: 0 auto;"></el-progress>
    </div>
    <!--第三步提示语 -->
    <div class="tip-desp y-fs-16" v-if="active==3">打印机打印完成后，如发现漏打情况，您可在 <span class="y-fc-4C84FF">统计分析-打印记录</span> 页面中查看该批次详情，补打漏单</div>
    <!-- 全部拉单失败或全部进入打印机 才可以出现关闭按钮-->
    <div style="margin-top:20px;text-align:center;">
      <el-button type="primary" @click="closeDialog" v-if="(active==3 || isAllFailed)">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dyPrint from '@/utils/douyinPrint';
import util from '@/utils/util';
import printWarningTip from '@/components/printWarningTip/printWarningTip'; // 打印组件未识别提示语
import { dateFormat } from '../../../../utils/util';
import { printPackageWaybillInfo, getPrintWayBillInfo, printPackageOfWayBillInfo, printPackageInfo } from '@/api/waybillPrint/buildPackge';
import { applyWaybillResultApi } from '../../../../api/waybillPrint/commonPrint';
export default {
  components: {
    printWarningTip // 打印组件未识别提示语
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      isShow: false,
      checked: false,
      fileType: 'xlsx',
      active: 1,
      title: '',
      alertTitle: '',
      pddAlertTitle: '',
      nowNum: 0,
      successAll: false,
      errOrders: [], // 拉单返回错误信息
      deliveryErrors: [], // 发货错误信息
      isApplyOrderFinished: false, // 是否拉单完成
      printBatch: '',
      dyAlertTitle: '', // 抖音打印组件
      dygfWaybillList: util.dygfWaybillList, // 抖音官方模板
      curOrderNumber: '', // 当前正在获取运单号的订单
      failedList: [], // 拉单失败数据
      successList: [], // 拉单成功数据
      innerVisible: false, // 内嵌表格开关
      defaultTempUrl: {}, // 当前打印模板
      printPercentage:0, // 计算的打印进度
      isAllFailed: false, // 是否全部拉单失败
      data: {},
      tempInfo: {},
      formInfo: {},
      netSendInfo: {},
      isPrintPackageSign: '', // 是否是只打包签
      isPrintWaybillSign: false, // 只打运单
      curPrintMailNoList: [], // 已发送给打印机的运单号集合， 用于发送打印任务时去重处理，防止重复下发打印任务
      curBaoSignNoList: []
    };
  },
  methods: {
    init() {
      this.dyAlertTitle = dyPrint.printerObj.alertTitle;
      this.errOrders = [];
      this.nowNum = 0;
      this.active = 1; // 当前订单状态，第一步，共三步
      this.isApplyOrderFinished = false;
      this.isShow = true; // 打印打印框
      this.batchPrinting();
    },
    closeDialog() {
      this.resetStatusFormDialog();
      this.$emit('close-print-dialog');
    },
    // 弹层状态重置
    resetStatusFormDialog() {
      this.isShow = false;
      this.active = 1;
      this.errOrders = [];
      this.deliveryErrors = [];
      this.isApplyOrderFinished = false;
      this.curOrderNumber = '';
      this.failedList = []; // 拉单失败数据
      this.successList = []; // 拉单成功数据
      this.innerVisible = false; // 内嵌表格开关
      this.defaultTempUrl = {}; // 当前打印模板
      this.isAllFailed = false;
      this.isDeliverFinish = false;
      this.curPrintMailNoList = [];
      this.curBaoSignNoList = [];
    },
    // 分批次拉单
    async getOrderListSplit(data, defaultTmpl) {
      // console.log(data);
      this.curOrderNumber = data[0].mailNo || data[0].packageWaybillNo;
      // console.log('this.curOrderNumber', this.curOrderNumber);
      return new Promise((resolve, reject) => {
        if (this.isPrintPackageSign == 'BULK' || this.isPrintPackageSign == 'PIKUP_BULK') {
          // 打印散单
          let params = {
            printType: this.isPrintPackageSign == 'PIKUP_BULK' ? 5 : 1, // 1 散件打印， 2 整包打印  3仅打包签, 4包签内运单打印, 5上车里的散件打印
            mailNoList: data.map(o => { return o.mailNo || o.packageWaybillNo; }),
            mallCode: this.formInfo.curMallCode,
            platformCode: "LUBAN",
          }; 
          getPrintWayBillInfo(params).then(res => {
            if (res.success) {
              let newObj = res.data || {};
              resolve(newObj);
            } else {
              let orderList = [];
              for (let p = 0; p < data.length; p++) {
                orderList.push({
                  logisticNo: data[p].mailNo || data[p].packageWaybillNo,
                  errorMsg: res.message || '获取打印数据失败，请稍候重试。'
                });
              }
              resolve({fail: orderList});
            }
          }).catch((error) => {
            let orderList = [];
            for (let p = 0; p < data.length; p++) {
              orderList.push({
                logisticNo: data[p].mailNo || data[p].packageWaybillNo,
                errorMsg: error.message || '获取打印数据失败，请稍候重试。'
              });
            }
            resolve({fail: orderList});
          });
        }
        if (this.isPrintPackageSign == 'WAYBILL') {
          // 只打印运单
          let params = {
            printType: 4, // 1 散件打印， 2 整包打印  3仅打包签, 4包签内运单打印, 5上车里的散件打印
            packageWayBillNo: this.formInfo.packageWaybillNo,
            mallCode: this.formInfo.curMallCode,
            platformCode: "LUBAN",
            mailNoList: data.map(o => { return o.mailNo; })
          };
          printPackageOfWayBillInfo(params).then(res => {
            if (res.success) {
              let newObj = res.data || {};
              resolve(newObj);
            } else {
              let orderList = [];
              for (let p = 0; p < data.length; p++) {
                orderList.push({
                  logisticNo: data[p].mailNo,
                  errorMsg: res.message || '获取打印数据失败，请稍候重试。'
                });
              }
              resolve({fail: orderList});
            }
          }).catch((error) => {
            let orderList = [];
            for (let p = 0; p < data.length; p++) {
              orderList.push({
                logisticNo: data[p].mailNo,
                errorMsg: error.message || '获取打印数据失败，请稍候重试。'
              });
            }
            resolve({fail: orderList});
          });
        } else if (this.isPrintPackageSign == 'BAO') {
          // 只打包签
          let params = {
            printType: 3, // 1 散件打印， 2 整包打印  3仅打包签 4包签内运单打印, 5上车里的散件打印
            packageWayBillNo: data[0].packageWaybillNo,
            mallCode: this.formInfo.curMallCode,
            platformCode: "LUBAN",
          };
          printPackageInfo(params).then(res => {
            if (res.success) {
              let newObj = res.data || {};
              resolve(newObj);
            } else {
              let orderObj = {
                fail: [{
                  logisticNo: data[0].packageWaybillNo,
                  errorMsg: res.message || '拉单接口失败，请稍候重试。'
                }]
              };
              resolve(orderObj);
            }
          }).catch((error) => {
            let orderObj = {
              fail: [{
                logisticNo: data[0].packageWaybillNo,
                errorMsg: res.message || '拉单接口失败，请稍候重试。'
              }]
            };
            resolve(orderObj);
          });
        } else if (this.isPrintPackageSign == 'ALL') {
          // 整包打印
          let params = {
            printType: 2, // 1 散件打印， 2 整包打印  3仅打包签 4包签内运单打印, 5上车里的散件打印
            packageWayBillNo: data[0].packageWaybillNo,
            mallCode: this.formInfo.curMallCode,
            platformCode: "LUBAN",
          };
          printPackageWaybillInfo(params).then(res => {
            if (res.success) {
              let newObj = res.data || {};
              resolve(newObj);
            } else {
              let orderObj = {
                fail: [{
                  logisticNo: data[0].packageWaybillNo,
                  errorMsg: res.message || '拉单接口失败，请稍候重试。'
                }]
              };
              resolve(orderObj);
            }
          }).catch((error) => {
            let orderObj = {
              fail: [{
                logisticNo: data[0].packageWaybillNo,
                errorMsg: error.message || '获取数据失败，请稍候重试。'
              }]
            };
            resolve(orderObj);
          });
        }
      });
    },
    splitArr(list, str) {
      // 将选中的数据每10个分成一组
      let result = [];
      for (let i = 0; i < list.length; i += 10) {
        let childList = list.slice(i, i + 10);
        if (str) {
          let taskId = `task_${util.getUUID(8, 16)}|${this.printBatch}`;
          childList[0].taskId = taskId;
        }
        result.push(childList);
      }
      return result;
    },
    splitArrForBaoSign(list, str) {
      // 按包签给数据分组
      // 先将包签的索引记录下来
      let splitBaoSignIndexList = [];
      for (let i = 0; i < list.length; i++) {
        let obj = list[i];
        if (obj.waybillType == '1') {
            splitBaoSignIndexList.push(i);
        }
      }
      // 按包签分隔数组，格式如： 一个包签，10个面单的分组，一个包签，10个面单的分组...
      let result = [];
      let j = 0;
      for (let i = 0; i < splitBaoSignIndexList.length; i++) {
        let index = splitBaoSignIndexList[i];
        if (index - j > 1) {
          let newArr = list.slice(j + 1, index);
          //包签下的面单数据添加次序
          let curNum = 0;
          newArr = newArr.map(o => {o.curNum = ++curNum; o.totalNum= newArr.length; return o;});
          //超过10个的面单数据分隔成10个一组,并给每组添加taskId
          let splitList = this.splitArr(newArr, 'addTaskId');
          result = result.concat(splitList);
        }
        // 包签数据,并给包签数据添加taskId
        let baoObj = list[index];
        baoObj.taskId = `task_${util.getUUID(8, 16)}|${this.printBatch}`;
        baoObj.curNum = 0;
        baoObj.totalNum = this.totalWaybillNum; // 这个值不好统计--此处无用
        result.push([baoObj]);
        j = index;
        // 最后一组包签下的面单数据
        if (i == splitBaoSignIndexList.length -1  && index < list.length) {
          let newArr = list.slice(j + 1, list.length);
          //最后一组包签下的面单数据添加次序
          let curNum = 0;
          newArr = newArr.map(o => {o.curNum = ++curNum; o.totalNum= newArr.length; return o;});
          //超过10个的面单数据分隔成10个一组,并给每组添加taskId
          let splitList = this.splitArr(newArr, 'addTaskId');
          result = result.concat(splitList);
        }
      }
      return result;
    },
    // 将一维数据转成二维
    splitArrForOne(list) {
      // 将选中的数据每10个分成一组
      let result = [];
      list.forEach(item => {
        result.push([item]);
      })
      return result;
    },
    // 多条打印
    async batchPrinting() {
      this.title = '获取运单号';
      this.active = 1;
      this.nowNum = 0;
      let _this = this;
      let result = [];
      if (this.isPrintPackageSign == 'WAYBILL' || this.isPrintPackageSign == 'BULK') {
        // 10个一组调用拉单接口-- 只打印运单， 打印散件时可10个一组调用拉单接口
        result = _this.splitArr(_this.data);
      } else {
        // 单个调用拉单接口---整包打印，只打印包签时，一次一个调用拉单接口
        result = _this.splitArrForOne(_this.data);
      }
      let defaultTmpl = dyPrint.baseTemplateList[this.formInfo.cpCode||'YTO'][this.formInfo.baseTempId];
      let customTempUrl = this.tempInfo.cpMarkDownPath || '';  // 抖音官方自定义区域模板 fastDfs
      this.defaultTempUrl = {
        defaultTmpl,
        customTempUrl
      };
      // 整合所有拉单返回结果
      this.failedList = []; // 所有获取数据失败的
      this.successList = []; // 所有获取数据成功的
      for (let j = 0; j < result.length; j++) {
        let allObj = await this.getOrderListSplit(result[j], defaultTmpl);
        if (allObj.fail && allObj.fail.length) {
          this.failedList = this.failedList.concat(allObj.fail);
        }
        if (allObj.ok && allObj.ok.length) {
          this.successList = this.successList.concat(allObj.ok);
        }
      }
      console.log('this.failedList', this.failedList);
      console.log('this.successList', this.successList);
      // 全部拉单完成
      this.isApplyOrderFinished = true;
      this.totalWaybillNum = this.successList.length; // 面单总个数
      this.isAllFailed = (!this.successList.length && this.isApplyOrderFinished) // 是否全部拉单失败--拉完单后，没有拉单成功的数据，就是全部都拉失败了
      if (this.failedList.length) {
        // 有获取打印数据失败的，则显示失败弹框
        this.innerVisible = true;
        let tempHtml = `<div><div class="y-f y-f-as y-f-b y-fs-16"><div style="width:50px;"> </div><div style="width: 220px;">包签号/运单号</div><div>结果</div></div></div>`
        for (let f = 0; f < this.failedList.length; f++ ) {
          tempHtml += `<div class="y-f y-f-as y-mt-10"><div style="width:50px;">${f+1}. </div><div style="width: 220px;">${this.failedList[f].mailNo || this.failedList[f].logisticNo || this.failedList[f].packageWaybillNo}</div><div>${this.failedList[f].errorMsg || '---'}</div></div>`
        }
        let tipTitle = `打印失败详情`;
        this.$alert(tempHtml, tipTitle, {
          customClass: 'nPrintOrdersStyle center-tn',
          dangerouslyUseHTMLString: true,
          callback: action => {
            // 当全部获取失败时，关闭弹框之后底层框全部关闭，并刷新列表---要不要刷列表，刷一下，可能有新运单进入， 
            // 当有部分失败时，什么都不做，只是关闭弹层，因为打印机正在打印剩下的，可能打印任务没有发送完毕，不能关闭底层框并刷列表
            if (this.isAllFailed) {
              this.closeDialog();
            }
          }
        });
      }
      if (this.successList.length) {
        // 没有拉单失败的，则正常进入打印步骤
        await this.continuePrintFn();
      }
    },
    // 继续打印
    continuePrintFn() {
      if (this.successList.length) {
        // 缓存批次打印信息，用于打印日志获取参数
        let printListRecord = [];
        let printRecordParams = localStorage.getItem('gPPP');
        if (printRecordParams) {
          printListRecord = JSON.parse(printRecordParams);
          if (printListRecord.length > 2) {
            printListRecord = printListRecord.slice(printListRecord.length-2);
          }
        }
        printListRecord.push(this.getParams({}));
        localStorage.setItem('gPPP', JSON.stringify(printListRecord));
        // 处理打印，按包签-面单顺序 分组后打印
        let newSuccessList = [];
        if (this.isPrintPackageSign == 'WAYBILL' || this.isPrintPackageSign == 'BAO' || this.isPrintPackageSign =='BULK' || this.isPrintPackageSign  == 'PIKUP_BULK') {
          // 只打印面单/包签，只做10个分组
          newSuccessList = this.splitArr(this.successList, 'addTask');
        } else {
          // 整包打印，需按包签分组后，再10个分组--包签模板和面单模板地址不一样，不能放在同一个打印任务中打印
          newSuccessList = this.splitArrForBaoSign(this.successList);
        }
        console.log('newSuccessList', newSuccessList);
        // 正常给打印机任务
        this.title = '开始打印';
        this.active = 2;
        this.nowNum = 0; // 开始总序号--包裹和面单总和
        for (let j = 0; j < newSuccessList.length; j++) {
          let childList = newSuccessList[j];
          if (childList[0].waybillType == '1') {
            // 走包签打印逻辑
            let printBaoSignData = [{
              "qrCodeStr": {mm: (childList[0].packageWaybillNo || ''), dtb: (childList[0].threeCode || ''), dest: (childList[0].openPageOrg || ''), src: (childList[0].startBranch || '')},
              "printTime": dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss'),
              "expireDate": `建包截止：${childList[0].packageExpiredatetime || ''}`,
              "threeCode": childList[0].threeCode || '',
              "dtbChildText": "",
              "packageWaybillNo": childList[0].packageWaybillNo || '',
              "startBranch": childList[0].startBranch || '',
              "openPageOrg": childList[0].openPageOrg || '',
              "openPageOrgName": childList[0].openPageOrgName || '',
              "buildPageName": childList[0].buildPageName || '',
              "printNum": 1,
              "curNum": 0,
              "totalNum": ((newSuccessList[j + 1] && newSuccessList[j + 1].length) ? newSuccessList[j + 1][0].totalNum : childList.length)
            }];
            let taskId = childList[0].taskId;
            this.printBaoSign(printBaoSignData, taskId);
          } else {
            // 整包打印逻辑
            this.batchPrintOrders(childList, j);
          }
        }
      }
    },
    // 多条打印
    async batchPrintOrders(list, paramsIi) {
      console.log('list--', list);
      let printList = [];
      let randomTaskId = list[0].taskId;
      for (let i = 0; i < list.length; i++) {
        let value = list[i];
        ++this.nowNum; // 展示打印进展，当前打印第几条
        let mailNo = value.mailNo; // 当前运单号
        let oldDataInfo = {};
        // 其它物流公司拉取各平台面单
        oldDataInfo = {
          // 非加密串字段--普通面单打印
          OrderNumber: value.orderNo,
          LogisticCode: value.mailNo,
          MailNo: value.mailNo,
          ToName: value.receiverName || '',
          ToMobile: value.receiverMobile || '',
          ToTelphone: value.receiverPhone || '',
          ToAdress: `${value.receiveProv || ''}${value.receiveCity || ''}${value.receiveDict || ''}${value.receiveAddress || ''}`,
          ToProvince: value.receiveProv || '',
          FromName: value.senderName || '',
          FromMobile: value.senderMobile || '',
          FromTelphone: value.senderPhone || '',
          FromCity: `${value.sendProv || ''}${value.sendCity || ''}${value.sendDict || ''}${value.sendAddress || ''}`,
          Remark: value.sellersRemark || '', // 卖家备注
          BuyerMemo: value.buyersRemark || '', // 买家备注信息
          Volume: '',
          Weight: '',
          Items: [],
          isShowLogo: this.tempInfo.isShowLogo || 'N', // 面单是否打印logo
          ThreeSegmentCode: value.shortAddress || '', // 三段码
          PackageName: value.packageCenterName || '', // 集包地
          PackagePosition: value.packageCenterCode || '', // 集包地编码
          printNum: value.printNum || '', // 面单重复打印次数
          totalNum: value.totalNum || this.totalWaybillNum, // 总面单个数
          curNum: value.curNum || this.nowNum, // 当前打印面单个数
          printKeyWord: value.printKeyWord || '', // 圆准达面单中返回的五级地址
          // 增值服务类型
          InsuranceValue: value.supportValue ? value.supportValue : 0, // 保价金额
          agencyFund: value.agentValue ? value.agentValue : 0, // 代收金额
          Buy_service_fee: value.apvalue ? value.apvalue : 0, // 到付金额
          // 加密串字段---CN/PDD 打印
          printData: value.printData,
          orderSn: value.orderNo, // 拼多多订单号
          trackingNumber: value.mailNo, // 拼多多运单号
          sendCity: `${value.sendProv || ''}${value.sendCity || ''}${value.sendDict || ''}`,
          sendAddress: value.sendAddress || '',
          sendName: value.senderName || '',
          sendMobile: value.senderMobile || '',
          sendPhone: value.senderPhone || '',
          receiveName: value.receiverName || '',
          receiveMobile: value.receiverMobile || '',
          receivePhone: value.receiverPhone || '',
          receiveAddress: `${value.receiveProv || ''}${value.receiveCity || ''}${value.receiveDict || ''}${value.receiveAddress || ''}`,
          // 加密串附代，必须有
          printParamsString: value.paramString || '',
          // 加密串字段---CN/PDD 打印
          printData: JSON.parse(value.printData).print_data || '',
          // 抖音加密签名
          signature: JSON.parse(value.printData).sign || '',
          // 抖音收件人省市区信息
          receiveCity: value.receiveCity || '',
          receiveAddress: value.receiveAddress || '',
          receiveDist: value.receiveDict || '',
          receiveProvince: value.receiveProv || '',
          logisticsId: value.logisticsId, // 快递公司id
          MallCode: value.mallCode, // 店铺id
          mallName: value.mallName || '', // 店铺id
          buyerMemo: value.buyersRemark || '', // 买家留言
          remark: value.sellersRemark || '' // 卖家备注
        };
        let goodsTotal = 0;
        let goodsTotalPrice = 0;
        value.goodInfoResponseList.forEach((item, index) => {
          goodsTotal += Number(item.productNum || 1);
          goodsTotalPrice += Number(item.productPrice || 0) * 10000 * Number(item.productNum || 1); //订单总金额
          let proInfo = {
            productPic: item.goodsImg || '',
            goodsname: item.productName || '',
            goodsnum: (item.productNum || 1) + `(${this.tempInfo.goodsNumUnit || '件'})`,
            goodsspec: item.productSpec || '', // 商品规格
            skucode: item.productSku || '', // sku编码
            goodscode: item.productId || '', // 商品编码
            item_short_name: item.productShortName || '', // this.formInfo.selectedOption.includes('打印商品简称') ? (item.goodShortName || '') : '', // 用于打印面单纸商品简称， 设置了简称并勾选了简称再打印简称，否则打印全称
            goodShortName: item.productShortName || '', // 商品简称
            goodsprice: (item.productPrice || 0) + '(元)'
          };
          oldDataInfo.Items.push(proInfo);
        });
        oldDataInfo.Items = JSON.stringify(oldDataInfo.Items);
        oldDataInfo.goodsTotal = goodsTotal + `(${this.tempInfo.goodsNumUnit || '件'})`; // 商品总数
        oldDataInfo.goodsTotalPrice = goodsTotalPrice / 10000; //订单总金额
        oldDataInfo.presentInfo = ''; // 赠品信息
        oldDataInfo.goodsOrderList = []; // value.goodsOrderList || [];
        printList.push({value: oldDataInfo, oldData: oldDataInfo});
      }
      // 打印任务---
      if (printList.length) {
        // 打印快递单
        this.printData(printList, randomTaskId, paramsIi);
      } else {
        // 打印数据收集异常...
      }
    },
    // 打印组件传递任务--打印面单
    printData(parintDataList, taskId, paramsIi) {
      // 开始打印
      /*
        this.formInfo.printer 指定打印机
        parintDataList 拉单的数据
        templatInfo 自定义打印信息
        defaultTempUrl 打印模板
        isEncrypt 是否加密
        storeType 平台店铺
        taskId 打印任务id
      */
      let curMailNoList = parintDataList.map(o => {return o.oldData.MailNo; });
      console.assert(false, curMailNoList)
      // console.log('curMailNoList', curMailNoList);
      // 当前任务中的运单号如没有被打印过，则下发打印任务
      if (!this.curPrintMailNoList.includes(curMailNoList[0])) {
        this.curPrintMailNoList = this.curPrintMailNoList.concat(curMailNoList);
        // 抖音官方密文打印
        dyPrint.printToDoList(this.formInfo.printer, parintDataList, Object.assign({}, this.tempInfo, this.defaultTempUrl), true, 'LUBAN', taskId);
        // 保存日志参数
        let paramsObj = {
          parintDataList,
          taskId,
          splitI: paramsIi,
          totalNum: this.successList.length,
          platFormCode: 'LUBAN',
          printBatch: this.printBatch
        };
        applyWaybillResultApi(paramsObj);
      }
      // 计算进度
      this.printPercentage = Math.floor((Number(this.nowNum) / this.successList.length)*100);// 计算打印进度
      if (this.nowNum == this.successList.length) {
        this.title = '打印成功';
        this.active = 3;
      }
    },
    // 打印包签
    printBaoSign(printBaoSignData, taskId) {
      // 包签可能会有重复的,去重打印
      let curBaoSignNOList = printBaoSignData.map(o => {return o.packageWaybillNo; });
      console.assert(false, curBaoSignNOList)
      // console.log('curBaoSignNOList', curBaoSignNOList);
      if (!this.curBaoSignNoList.includes(curBaoSignNOList[0])) {
        this.curBaoSignNoList = this.curBaoSignNoList.concat(curBaoSignNOList);
        this.nowNum += printBaoSignData.length;
        dyPrint.printBaoSignList(this.formInfo.printer, printBaoSignData, taskId);
      }
      // 计算进度
      this.printPercentage = Math.floor((Number(this.nowNum) / this.successList.length)*100);// 计算打印进度
      if (this.nowNum == this.successList.length) {
        this.title = '打印成功';
        this.active = 3;
      }
    },
    // 打印日志参数获取
    getParams(params) {
      let recordParams = {
        printUserId: this.userMess.loginId,
        platFormCode: 'JBDY', // 平台类型code
        platFormName: '建包打印(抖音)', // 平台名称
        printBatch: this.printBatch, // 批次
        printSequence: params.printSequence || '', // 次序
        printStatus: params.printStatus || '', // 打印状态（Y/N）
        mailNo: params.mailNo || '', // 运单号
        expressModelId: this.tempInfo.baseTempId, // 快递单模板基础类型
        cpCode: this.tempInfo.wpCode, // 快递模板公司
        printModel: this.tempInfo.id, // 快递单模板id
        printModelName: this.tempInfo.tempName, // 快递模板名称
        applyOrderAccount: '', // 拉单账号
        printOrderNum: this.totalWaybillNum, // 批次下所有拉单返回的运单号总数
        printTime: params.printTime || dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss'), // 打印时间
        printerName: this.formInfo.printer, // 打印机名称
        shopName: this.formInfo.curMallName, // 店铺名称
        shopId: this.formInfo.curMallId, // 店铺id
        taskId: '' // 任务id     
      };
      return recordParams;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../../../styles/variables";
.alert {
  margin-bottom: 30px;
}
.el-dialog__wrapper .successAll {
  text-align: center;
  color: $blue-style;
  i {
    font-size: 30px;
  }
  p {
    font-size: 16px;
    margin-bottom: 0;
  }
}
.el-dialog__header .el-dialog__title {
  font-size: 16px;
}
.tip-desp {
  margin-top: 20px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
}
</style>
